import backend from '@common/backend';

const BASE = '/student-profile';

export const getStudentProfile = (studentId: number) =>
	backend.get(`${BASE}`, { params: { student_id: studentId } });

export const saveStudentProfile = async (data: any) => backend
	.patch(`${BASE}`, data);

export const getProfilebyStudent = () => backend.get('profile-for-student', {});

export const getProfileForParent = (student_id: number) => backend.get(`profile-for-parent/${student_id}`, {});
